
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class RxSnackbar extends Vue {
    @Prop({ required: true })
    id !: string;

    private showMe: boolean = false;
    private timeout : number = -1;
    private color : string = "info";
    private message : string = "";

    show(color : string, message : string) {
        this.color = color;
        switch (color) {
            case "error":
            case "warning":
                this.timeout = 0;
                break;
            case "info":
                this.timeout = 5000;
                break;
        }
        this.message = message;
        this.showMe = true;
    }

    showError(message : string) {
        this.show("error", message);
    }

    showInfo (message : string) {
        this.show("info", message);
    }

    showWarning (message : string) {
        this.show("warning", message);
    }

    clear () {
        this.message = "";
        this.showMe = false;
    }
}
